import React, { MouseEventHandler } from 'react';
import { ArrowForwardIos, ArrowBackIos } from '@material-ui/icons';
import { IntlShape, injectIntl } from 'react-intl';
import styled from 'styled-components';

import { BUTTON_COLORS, COLORS } from 'constants/design';
import messages from 'components/navigationButtons/messages';
import { translate } from 'containers/services/translate';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';

const Container = styled.div`
  &&.container {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    position: absolute;
    right: 64px;
    left: 64px;
    width: 89%;
    bottom: -30px;
    margin-bottom: 20px;
  }
  .arrowBack {
    margin-right: 25px;
    width: 15px;
  }
  .arrowForward {
    margin-left: 25px;
    width: 15px;
    fill: ${COLORS.WHITE};
  }
  &&.hidden {
    display: none !important;
    opacity: 0;
  }
`;

export interface navigationButtonsProps {
  intl: IntlShape;
  forwardClick?: MouseEventHandler;
  onPreviousClick?: MouseEventHandler;
  isRecap?: boolean;
  isPreOpen?: boolean;
  disabledMoveButton?: boolean;
}

const navigationButtons: React.FC<navigationButtonsProps> = (
  props,
): JSX.Element => {
  return (
    <div>
      <Container className={!props.isPreOpen ? 'container' : 'hidden'}>
        <SecondaryButton
          title={translate(messages.navigationButtonsBack, props)}
          onClick={props.onPreviousClick}
          lefticon={<ArrowBackIos className="arrowBack" />}
        />
        <PrimaryButton
          title={
            !props.isRecap
              ? translate(messages.navigationButtonsMove, props)
              : translate(messages.navigationButtonSave, props)
          }
          onClick={props.forwardClick}
          righticon={<ArrowForwardIos className="arrowForward" />}
          background={BUTTON_COLORS.PRIMARY_BLUE}
          border={BUTTON_COLORS.PRIMARY_BLUE}
          titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
          disabled={props.disabledMoveButton}
        />
      </Container>
    </div>
  );
};

export default injectIntl(navigationButtons);
